import { render } from "./EditConcessions.vue?vue&type=template&id=7446d78f&scoped=true"
import script from "./EditConcessions.vue?vue&type=script&lang=js"
export * from "./EditConcessions.vue?vue&type=script&lang=js"

import "./EditConcessions.vue?vue&type=style&index=0&id=7446d78f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7446d78f"]])

export default __exports__